import { getShowAmazonLink } from "../lib/amazonLink.js";

export function WatchCTA(show) {
  const amazonLink = getShowAmazonLink(show);
  if (!amazonLink) return null;

  const el = document.createElement("a");
  el.className = "watch-cta";
  el.href = amazonLink;
  el.target = "_blank";
  el.rel = "noopener noreferrer sponsored";
  el.textContent = "Watch on Amazon";
  el.addEventListener("click", () => {
    console.log("amazon_cta_clicked", show.id);
  });

  return el;
}
